<div [style.height]="data.height"></div>
